import React from "react"
import { useSelector } from "react-redux"
import _ from "lodash"

import { CRUISE_LINE_FIELD_PLACEHOLDER } from "@/onboarding/features/product/models/Product"
import { isOperatorTourIdea } from "@/onboarding/features/product/selectors"
import { isBlank } from "@/utils"
import { EmptyMessage } from "@/components/input/SingleSelect"

import TextDisplay from "./TextDisplay"

const isReferencedValueBlank = (value): boolean => {
  if (_.isNil(value)) {
    return true
  }

  if (_.has(value, "type") && _.has(value, "value")) {
    return isBlank(value.value)
  }

  return false
}

const ReferencedValueDisplay = ({ value, previousValue = false }) => {
  const isTourOperatorIdea = useSelector(isOperatorTourIdea)

  if (isTourOperatorIdea && isReferencedValueBlank(value)) {
    return <EmptyMessage message={CRUISE_LINE_FIELD_PLACEHOLDER} />
  }

  return <TextDisplay value={value} previousValue={previousValue} />
}

export default ReferencedValueDisplay
